module.exports = __webpack_public_path__ + "static/media/C5aug.5422aca6.wav";